const useParentPath = (location: any) => {
	const pathSegments = location.pathname.split("/").filter(Boolean);
	const parentPath = "/" + pathSegments.slice(0, -1).join("/");
	return parentPath;
};

export default useParentPath;
